<template>
  <div class="coq-modal">
    <div class="coq-modal__top-right">
      <a @click="$emit('close')">
        <font-awesome-icon icon="times" type="fas" size="lg"/>
      </a>
    </div>

    <h3>Gérer l'inscription à cette activité</h3>

    <template v-if="!haveActiveSubscription">
      <div style="padding-top: 20px; padding-bottom: 20px;">
        <p style="color: red; text-align: center !important; font-weight: 500; font-size: 14px;">
          Vous devez avoir un abonnement COQ actif pour pouvoir vous inscrire.
        </p>
        <p style="text-align: center !important; margin-top: 20px">
          Veuillez cliquer
          <router-link :to="{ name: 'MembersPage' }" @click.native="$emit('close')">ici</router-link>
          afin de choisir un type d'adhésion.
        </p>
      </div>
    </template>
    <template v-else>
      <p>
        Veuillez sélectionner les membres à inscrire à cette activité. Ceux-ci
        seront ajouté à la commande. Pour accéder à la commande pour compléter
        l'inscription, veuillez cliquer sur le bouton gris en bas de la fenêtre.
      </p>
      <br/>
      <h4>Membres non inscrits</h4>
      <table style="width: 100%">
        <tr
            v-for="member in members"
            class="class__registration__member"
            :key="member.id"
        >
          <template v-if="!memberAlreadyRegistered(member.id)">
            <td>
              <input
                  type="checkbox"
                  @change="registerMember($event, member.id)"
                  :checked="memberAlreadyInOrder(member.id)"
              />
            </td>
            <td style="width: 90%">
              {{ member.firstName }} {{ member.lastName }}
            </td>
          </template>
        </tr>
      </table>

      <br/>
      <h4>Membres déjà inscrits</h4>
      <table style="width: 100%">
        <tr
            v-for="member in members"
            class="class__registration__member"
            :key="member.id"
        >
          <template v-if="memberAlreadyRegistered(member.id)">
            <td>
              <input type="checkbox" disabled readonly checked/>
            </td>
            <td style="width: 90%">
              {{ member.firstName }} {{ member.lastName }}
            </td>
          </template>
        </tr>
      </table>

      <div class="coq-modal__footer">
        <a
            class="btn btn-secondary"
            style="margin-right: 10px; width: 85%"
            @click="$emit('close') && $router.push({ name: 'CartPage' })"
        >
          Aller au panier
        </a>
        <a class="btn btn-primary" @click="$emit('close')">
          Fermer
        </a>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import moment from 'moment';
  import _ from 'lodash';

  export default {
    name: 'activity-registration-modal',
    props: {
      activityId: {
        type: String
      }
    },
    data() {
      return {
        registrations: {}
      };
    },
    async beforeMount() {
      await this.getCart();
    },
    async mounted() {
      await this.fetchMembers();
    },
    computed: {
      ...mapGetters('services', {
        _getActivity: 'activity'
      }),
      ...mapGetters('orders', {
        cart: 'cart'
      }),
      ...mapGetters('account', {
        getUserInfos: 'getUserInfos'
      }),
      user() {
        return this.getUserInfos;
      },
      activity() {
        return this._getActivity(this.activityId);
      },
      members() {
        return this.$store.getters['members/getMembers'];
      },
      haveActiveSubscription() {
        return _.isObject(this.user.subscription) && moment(this.user.subscription.endDate).isAfter(moment());
      }
    },
    methods: {
      ...mapActions('orders', {
        getCart: 'getCart',
        upsertRegistration: 'upsertRegistration',
        deleteRegistration: 'removeRegistration'
      }),
      ...mapActions('members', {
        fetchMembers: 'fetchMembers'
      }),

      /**
       * Add or update the activity in the cart.
       */
      async registerMember(event, memberId) {
        if (event.target.checked === true) {
          this.upsertRegistration({
            registrationId: this.activityId,
            type: 'activity',
            memberId
          });
        }
        else if (event.target.checked === false) {
          this.deleteRegistration({
            registrationId: this.activityId,
            type: 'activity',
            memberId
          });
        }
      },
      memberAlreadyRegistered(memberId) {
        for (const r of this.activity.registrations) {
          if (r.member && r.member.id === memberId) {
            return true;
          }
        }
        return false;
      },
      memberAlreadyInOrder(memberId) {
        for (const r of this.cart.registrations) {
          if (
            r !== null &&
            r.member &&
            r.member.id === memberId &&
            r.activity &&
            r.activity.id === this.activityId
          ) {
            return true;
          }
        }
        return false;
      }
    }
  };
</script>

<style scoped></style>
